'use client';

import Image from 'next/image';
import Link from '@eliadmin/core/src/components/link';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { Heading } from '../ui/heading';
import { Paragraph } from '../ui/paragraph';
import { Button } from '../ui/button';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { SheetClose } from '../ui/sheet';

export function RegisterSuccess({ inDialog }: { inDialog?: boolean }) {
  const { t } = useTranslations();

  return (
    <div
      className={cn(
        'flex w-full flex-col items-center justify-center gap-8',
        !inDialog && 'pb-12 pt-48 sm:pb-16 sm:pt-52 lg:pt-64',
      )}
    >
      <div className="flex w-full flex-col items-center justify-center gap-6">
        <Image
          src={'/images/icons/double-check.svg'}
          alt={t('text3750')}
          height={48}
          width={48}
          className="shrink-0 object-contain"
        />
        <Heading title={t('text3750')} center />
        <Paragraph size="lg" className="w-full text-center text-[#666666]">
          {t('text3402')}
        </Paragraph>
      </div>
      <div className="grid w-full grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-4">
        <SheetClose asChild>
          <Button asChild className="col-span-1 w-full">
            <Link prefetch={false} href={ROUTES.PROFILE()}>
              {t('text1134')}
            </Link>
          </Button>
        </SheetClose>
        <SheetClose asChild>
          <Button asChild variant={'secondary'} className="col-span-1 w-full">
            <Link prefetch={false} href={ROUTES.HOME()}>
              {t('text2379')}
            </Link>
          </Button>
        </SheetClose>
      </div>
    </div>
  );
}
